export const Flex = (direction='row', align='stretch', justify='flex-start') => `
  display: flex;
  flex-direction: ${direction};
  align-items: ${align};
  justify-content: ${justify};
`;

export const Font = {
  bold: 'PretendardBold',
  extra_bold: 'PretendardExtraBold'
}